type FormRef = HTMLInputElement | HTMLTextAreaElement;
type GetUpdatedTextWithAttribute = <T>(
  currentText: string,
  attribute: string,
  ref?: FormRef,
  showOnlyNameAttributes?: boolean,
) => string;

export const getUpdatedTextWithAttribute: GetUpdatedTextWithAttribute = (
  currentText,
  attribute,
  ref,
  showOnlyNameAttributes = false,
) => {
  const text = currentText || '';
  if (ref) {
    const start = ref.selectionStart;
    const end = ref.selectionEnd;
    if (text && start && end) {
      if (showOnlyNameAttributes) {
        return `${text.substr(0, start)}{{user_${attribute
          .split(' ')
          .join('_')}}}${text.substr(end, text.length)}`;
      }
      return `${text.substr(0, start)}{{${attribute}}}${text.substr(
        end,
        text.length,
      )}`;
    }
  }
  if (showOnlyNameAttributes) {
    return `${text}{{user_${attribute.split(' ').join('_')}}}`;
  }
  return `${text}{{${attribute}}}`;
};
